// src/components/footer.js

import React from 'react';
import { Box, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const logo = `${process.env.PUBLIC_URL}/img/logo.png`;

const FooterContainer = styled(Box)`
  background-color: #1b1b1b;
  color: #fff;
  padding: clamp(32px, 6vw, 60px) 20px;
  width: 100%;
  box-sizing: border-box;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow-x: hidden;

  @media (min-width: 768px) {
    flex-direction: row;
    justify-content: space-between;
    padding-left: clamp(32px, 8vw, 100px);
    padding-right: clamp(32px, 8vw, 100px);
    gap: 32px;
  }
`;

const FooterLogo = styled.img`
  height: 100px;
  margin-bottom: 20px;

  @media (min-width: 768px) {
    margin-bottom: 0;
  }
`;

const ContactDetails = styled(Box)`
  text-align: center;
  margin-bottom: 20px;
  max-width: 560px;

  @media (min-width: 768px) {
    text-align: left;
    margin-bottom: 0;
  }

  a {
    color: #fff;
    text-decoration: none;
    font-weight: bold;
    &:hover {
      color: #f4b642;
    }
  }
`;

const FooterNav = styled(Box)`
  margin-top: 20px;
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  justify-content: center;

  @media (min-width: 768px) {
    margin-top: 0;
    justify-content: flex-start;
  }

  a {
    color: #fff;
    text-decoration: none;
    font-weight: bold;
    &:hover {
      color: #f4b642;
    }
  }
`;

const SocialIcons = styled(Box)`
  display: flex;
  gap: 15px;
  justify-content: center;
  margin-top: 20px;

  @media (min-width: 768px) {
    margin-top: 0;
  }

  a {
    color: #fff;
    font-size: 1.5rem;
    &:hover {
      color: #f4b642;
    }
  }
`;

const Footer = () => {
  return (
    <FooterContainer>
      <FooterLogo src={logo} alt="Gallery J Logo" />

      <ContactDetails>
        <Typography variant="body1">
          Woodview Coxtown, Dunmore East, Co. Waterford, X91 PP93
        </Typography>
        <Typography variant="body1">
          Phone: <a href="tel:+353868902920">+353 86 890 2920</a> |
          <a href="mailto:jeanenglisharts@gmail.com"> jeanenglisharts@gmail.com</a>
        </Typography>
      </ContactDetails>

      <FooterNav>
        <Link to="/">Home</Link>
        <Link to="/about">About</Link>
        <Link to="/gallery">Gallery</Link>
        <Link to="/contact">Contact</Link>
      </FooterNav>

      <SocialIcons>
        <a href="https://instagram.com" target="_blank" rel="noreferrer">
          <i className="fab fa-instagram"></i>
        </a>
        <a href="https://facebook.com" target="_blank" rel="noreferrer">
          <i className="fab fa-facebook"></i>
        </a>
      </SocialIcons>
    </FooterContainer>
  );
};

export default Footer;
